import { format } from "date-fns";

export const formatInvoiceDate = (date: string | null) => (date ? format(new Date(date), "MMM dd, yyyy") : "N/A");
